// extracted by mini-css-extract-plugin
module.exports = {"logo":"store-styles_logo__1smol","commercial_registration":"store-styles_commercial_registration__3bLV7"};